<template>
    <div class="ur-data-grid__edit__element ur-data-grid__edit__dropdown" @mousedown.stop="()=>{}">
        <!-- [AREA] Title area -->
        <div class="ur-data-grid__edit__dropdown__title" :class="titleClass">
            <input class="ur-data-grid__edit__dropdown__title__input ur-data-grid__edit__element__input" 
                   :value="titleText" readonly v-ur-tooltip.empty="titleText"
                   @keydown="onKeydown" 
                   @keydown.enter="toggleItem(true)" @click="toggleItem" ref="anchor"
                   v-on="{...$listeners, input:()=>{}}"/>
            <ur-icon class="ur-data-grid__edit__dropdown__title__caret" 
                     borderless icon="expand_menu" :class="caretClass" @click="toggleItem" />
        </div>
        <!-- [AREA] Title area END -->
        <!-- [AREA] Items area -->
        <dropdown-items :items="items" :anchor="$refs.anchor" :attach-root="attachRoot"
                :value="currVal" @input="onInput" v-if="itemsFlag"
                v-click-outside.anchor="closeItems"/>
        <!-- [AREA] Items area -->
    </div>
</template>

<script>
import dropdownItems from "./sub/urDataGridEditDropdownItems"
import clickOutside from '../common/direc/urDataGridClickOutside.js'

export default {
    name : 'urDataGridEditDropdown',
    components : {dropdownItems},
    props : {
        value : [String,Number,Object],
        items : {type:Array, default:() => []},
        //-------------------------
        attachRoot : {type:Boolean, default: false},
    },
    data() { return {
        currVal: '', // value for "input" element
        //-------------
        itemsFlag : false,
    }},
    computed : {
        // [COMPUTED] Values
        titleText() {
            var item = this.itemMap.get(this.currVal);
            return (item ? item.text : null) || this.currVal;
        },
        itemMap() {
            var map = new Map();
            if(!this.items) return map;
            this.items.forEach(it => {
                map.set(it.value,it);
            })
            return map;
        },
        // [COMPUTED] Style, Title class
        titleClass() {return {'ur-data-grid__edit__dropdown__title--active'       :this.itemsFlag}},
        // [COMPUTED] Style, Caret class
        caretClass() {return {'ur-data-grid__edit__dropdown__title__caret--expand':this.itemsFlag}}
    },
    watch : {
        value: {immediate: true, handler(val, old) {
            this.currVal = val; // when input comes
        }},
        // TODO items -> Normalized items??
    },
    methods : {
        // [METHODS] events
        onInput(v) {
            this.currVal = v;
            this.$emit('input',v);
            this.closeItems();
        },
        toggleItem(flag) {
            if(typeof flag==='boolean') {this.itemsFlag = flag}
            else {this.itemsFlag = !this.itemsFlag}
            this.$emit('on-flotage',this.itemsFlag);
        },
        closeItems() {
            this.toggleItem(false);
        },
        /* NOSONAR */onKeydown(e) {
            // ??? 몹시 느릴수도 있읍니다?
            //     Index도 넣고 Normalize하고 하는 속도개선이 가능합니다.
            //     Dropdown 항목이 500~1000개 이상일때는 큰일날듯..
            const keyCode = e.keyCode;
            const KEYCODE = {UP: 38, DOWN: 40};
            const currVal = this.currVal
            switch(keyCode) {
            case KEYCODE.UP:
                // 1. UP arrow
                e.preventDefault();
                // 1.1 Check value is empty
                if(currVal === null || currVal === undefined) {
                    let obj = this.items[this.items.length-1];
                    this.currVal = typeof obj === 'object' ? obj.value : obj;
                    this.$emit('input',this.currVal);
                    break;
                }
                // 1.2 Find previous
                var prev = null
                var res = this.items.find(item => {
                    if(item === currVal || item.value === currVal) {return true}
                    prev = item; // keep previous
                    return false;
                })
                // 1.3 Check something.
                if(!prev) break;
                if(res === undefined) break;
                // 1.4 Set value
                this.currVal = typeof prev === 'object' ? prev.value : prev
                this.$emit('input',this.currVal);
                break;
            case KEYCODE.DOWN:
                // 2. Down arrow
                e.preventDefault();
                // 2.1 Check value is empty
                if(currVal === null || currVal === undefined) {
                    let obj = this.items[0];
                    this.currVal = typeof obj === 'object' ? obj.value : obj;
                    this.$emit('input',this.currVal);
                    break;
                }
                // 2.2 Find next
                var nextIdx = -1;
                this.items.find((item,idx) => {
                    nextIdx = idx; // keep previous
                    if(item === currVal || item.value === currVal) {return true}
                    return false;
                })
                nextIdx++;
                var next = this.items[nextIdx];
                // 2.3 Check something.
                if(nextIdx>=this.items.length) break;
                if(!next) break;
                // 2.4 Set value
                this.currVal = typeof next === 'object' ? next.value : next;
                this.$emit('input',this.currVal);
                break;
            }
        },
        focus(opts) {
            this.$refs.anchor.focus(opts);
        }
    },
    directives: {'click-outside': clickOutside}
};
</script>